/**
 * Which version of the app this is, for the places that say so out loud.
 *
 * Two answers, because there are two builds. The desktop app asks the native layer, which
 * reports the version of the binary that is running right now — once an update installs itself
 * that is a different number from the one this bundle shipped with. The web app has no native
 * layer to ask, so it falls back to the number stamped in at build time, which on the web is
 * the same thing: the page is the release.
 */

import * as React from 'react';
import { isDesktop } from '../platform/index.js';
import { native } from '../platform/tauri.js';

/** The version in `src-tauri/tauri.conf.json` when this bundle was built. See `vite.config.ts`. */
export const BUNDLED_VERSION: string = __APP_VERSION__;

/** Asked once per session: the binary underneath cannot change while it is running. */
let running: string | null = null;

export function useAppVersion(): string {
  const [version, setVersion] = React.useState(running ?? BUNDLED_VERSION);

  React.useEffect(() => {
    if (!isDesktop || running) return;
    let live = true;
    native
      .deviceInfo()
      .then((info) => {
        running = info.appVersion;
        if (live) setVersion(info.appVersion);
      })
      // The bundled number is already on screen, and it is right often enough that a failed
      // native call is not worth showing anyone.
      .catch(() => {});
    return () => {
      live = false;
    };
  }, []);

  return version;
}
